export const getEnvVar = (key: string): string => {
    return (window as any)._env_?.[key] || process.env[key] || '';
};

export const ENV = {
    API_URL: () => getEnvVar('REACT_APP_API_URL'),
    FIREBASE_API_KEY: () => getEnvVar('REACT_APP_FIREBASE_API_KEY'),
    FIREBASE_AUTH_DOMAIN: () => getEnvVar('REACT_APP_FIREBASE_AUTH_DOMAIN'),
    FIREBASE_PROJECT_ID: () => getEnvVar('REACT_APP_FIREBASE_PROJECT_ID'),
    FIREBASE_STORAGE_BUCKET: () => getEnvVar('REACT_APP_FIREBASE_STORAGE_BUCKET'),
    FIREBASE_MESSAGING_SENDER_ID: () => getEnvVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
    FIREBASE_APP_ID: () => getEnvVar('REACT_APP_FIREBASE_APP_ID'),
};
